<template>
  <div class="ResetPassword">
    <NotificationBar
      v-if="error"
      :message="error"
      level="error" />

    <div class="panel">
      <h1>Reset password</h1>
      <template v-if="!didReset">
        <p>
          Enter your accounts email address to receive an email with
          instructions on how to reset your password.
        </p>
        <form @submit.prevent="reset()">
          <div class="form-group">
            <label for="id-email">Email</label>
            <input
              id="id-email"
              type="email"
              v-model="email">
          </div>
          <button
            class="btn"
            type="submit">
            Reset
          </button>
        </form>
      </template>
      <template v-if="didReset">
        <p>Please check your email inbox, and follow the instructions.</p>
      </template>
    </div>
  </div>
</template>

<script>
import NotificationBar from "@/components/NotificationBar";
export default {
  components: { NotificationBar },
  data: function () {
    return {
      email: "",
      error: "",
      didReset: false,
    };
  },

  props: {},

  mounted() {
    this.$store.dispatch("logout");
  },

  methods: {
    reset() {
      this.error = "";
      console.log("resetting");
      const payload = {
        email: this.email,
      };
      this.$store
        .dispatch("resetPassword", payload)
        .then(() => (this.didReset = true))
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.error = err.response.data.message;
          } else {
            this.error = err.message;
          }
        });
    },
  },

  computed: {},

  filters: {},
};
</script>

<style lang="scss" scoped>
.ResetPassword {
  padding: 1em;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

button {
  width: 100%;
}

.panel {
  padding: 1em;
  justify-self: center;
  align-self: center;
}

h1 {
  text-align: center;
}
</style>
